import { render } from "./BasicPageContent.vue?vue&type=template&id=447810c9&scoped=true&ts=true"
import script from "./BasicPageContent.vue?vue&type=script&lang=ts"
export * from "./BasicPageContent.vue?vue&type=script&lang=ts"

import "./BasicPageContent.vue?vue&type=style&index=0&id=447810c9&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447810c9"]])

export default __exports__